export const onyxBreakpoints = { md: 768, lg: 1024, xl: 1280 };
